import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Divider from "@mui/material/Divider";
import useForm, { Form } from "../../../../hooks/useForm";
import Controls from "../../../../components/form/controls/Controls";
import { validationDepartmentInput } from "../../../../utils";
import { getRoles } from "../../../../apis/System/role.api";

const initialValue = {
  id: "",
  name: "",
  description: "",
  roleIds: [],
};

function DepartmentForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;

  const [roles, setRoles] = useState([]);
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input employee
  const validateDepartmentForm = (fieldValues = values) => {
    let temp = validationDepartmentInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateDepartmentForm);

  useEffect(() => {
    // * Get list department
    getRoles({ page: 1, limit: 1000 }, (result) => {
      setRoles([...result.list]);
    });
  }, []);

  useEffect(() => {
    setErrors((errors) => ({
      ...errors,
      ...errorsForm,
    }));
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      // * push active role of department
      recordForEdit.roleIds = recordForEdit.roles.map((role) => role.id);
      setValues({
        ...recordForEdit,
      });
      setErrors({});
    } else {
      setValues({
        ...valueAddNew,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateDepartmentForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />
      <Controls.Input
        name="description"
        value={values.description}
        label="Description"
        type="text"
        onChange={handleOnChange}
        error={errors.description}
      />

      <Accordion
        sx={{
          marginTop: "10px",
          color: "var(--txt-color)",
          backgroundColor: "var(--main-bg)",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Roles</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            maxHeight: "300px",
            overflowY: "auto",
          }}
        >
          <Divider />
          <Controls.MultipleCheckbox
            name="roleIds"
            label="Role"
            value={values.roleIds}
            onChange={handleOnChange}
            options={roles}
          />
        </AccordionDetails>
      </Accordion>

      <Controls.Button
        sx={{ width: "100%", marginTop: "20px" }}
        type="submit"
        text="Submit"
      />
    </Form>
  );
}

export default DepartmentForm;
